import { useNavigate } from "react-router-dom";
import _ from "lodash";

import styles from "./styles.module.scss";

export function SmallTalkNotification({ message }) {
  const navigate = useNavigate();

  const url = `/engage/${_.get(message, 'sender.chatUser', '')}`;

  return (
    <div>
      <div className={styles.link} onClick={() => navigate(url)}>
        <div className={styles.notification}>
          <div className={styles.contact}>
            {_.get(message, 'sender.name', ).replace("null", "")}
          </div>
          <div className={styles.text}>{message.text}</div>
        </div>
      </div>
    </div>
  );
}